"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetAssetBlobURLBase = void 0;
const Entities_1 = require("../../Entities");
class GetAssetBlobURLBase extends Entities_1.RequestHandler {
    castPayloadV1(payload) {
        const castPayload = payload;
        if (!castPayload.assetID || !castPayload.callback) {
            throw new Entities_1.UnableToParsePayload(this.requestType, 1, JSON.stringify(payload));
        }
        return castPayload;
    }
    constructor(hostHandler) {
        super();
        this.requestType = "GET_ASSET_BLOB";
        this.action = () => {
            throw new Entities_1.ActionNotImplemented(this.requestType);
        };
        this.handleRequest = (version, payload) => {
            if (version === 1) {
                const { assetID, callback } = this.castPayloadV1(payload);
                this.action(assetID, callback);
            }
            else {
                throw new Entities_1.UnsupportedRequestVerion(this.requestType, version);
            }
        };
        hostHandler.registerRequestHandler(this);
    }
}
exports.GetAssetBlobURLBase = GetAssetBlobURLBase;
